import { FC } from 'react'

import GoBackButton from '@/components/shared/button/ui/GoBackButton'

type Props = {
  title?: string
  showBackButton?: boolean
  onClose?: () => void
  isMobile?: boolean
  className?: string
}

const RequestRatingHeader: FC<Props> = ({
  title,
  showBackButton = true,
  onClose,
  isMobile = false,
  className = ''
}) => {
  if (!isMobile) {
    return title
  }

  return (
    <div className={`flex items-center gap-8 ${className}`}>
      {showBackButton && onClose && <GoBackButton onClick={onClose} />}
      <p className="sm:text-20">{title}</p>
    </div>
  )
}

export { RequestRatingHeader }
